<template>
  <b-modal
    content-class="mymodalContent"
    modal-class="mymodal"
    id="save"
    size="lg"
    centered
    hide-header
    hide-footer
    @show="onShow"
  >
    <close-icon :title="$t('global.closePopinTitle')" @click="$bvModal.hide('save')" />
    <div class="modal-div">      
      <!-- ENREGISTREMENT -->
      <template v-if="userDataPresent">
        <!--   <p v-if="error">{{error}}</p>-->
        <h2 v-html="$t('components.popinSave.saveFile.title')"></h2>
        <div class="editorial" v-html="$t('components.popinSave.saveFile.text')"></div>
        <b-button class="refonte_btn-secondary popin-btn" @click="saveInJSON()">
          <download-icon title />
          {{ $t("components.popinSave.saveFile.btn") }}
        </b-button>
      </template>

      <!-- CHARGEMENT -->
      <h2 v-html="$t('components.popinSave.openFile.title')" @click="openPromptDebugDialog()"></h2>
      <div class="editorial" v-html="$t('components.popinSave.openFile.text')"></div>
      <b-button class="refonte_btn-secondary popin-btn" @click="openFileDialog()">
        <upload-icon title />
        {{ $t("components.popinSave.openFile.btn") }}
      </b-button>
      <b-form-file
        @change="openJSON($event)"
        accept=".gpsst"
        type="file"
        id="theFile"
        style="display:none"
      ></b-form-file>
    </div>

    <!-- Modale de confirmation de réécriture -->
    <b-modal
      content-class="mymodalContent"
      modal-class="mymodal"
      id="confirmOverwrite"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-div">
        <h2 v-html="$t('components.popinConfirmOverwrite.title')"></h2>

        <p v-html="$t('components.popinConfirmOverwrite.message')" class="message"></p>

        <div class="popin-actions">
          <b-button class="popin-btn-cancel" @click="cancelOverwrite()">
            <cancel-icon title />
            {{ $t('components.popinConfirmOverwrite.cancelBtn') }}
          </b-button>
          <b-button class="refonte_btn-primary popin-btn-confirm" @click="confirmOverwrite()">
            <check-icon title />
            {{ $t('components.popinConfirmOverwrite.confirmBtn') }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import { saveAs } from "file-saver";
import CloseIcon from "vue-material-design-icons/Close.vue";
import DownloadIcon from "vue-material-design-icons/Download.vue";
import UploadIcon from "vue-material-design-icons/Upload.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";
import axios from "axios";
import moment from "moment";
import md5 from "md5";

export default {
  name: "PopinOpenSave",
  components: {
    CloseIcon,
    DownloadIcon,
    UploadIcon,
    CancelIcon,
    CheckIcon
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    }
  },
  data: function() {
    return {
      userDataPresent: false,
      promptDebugDialogCount: 0
    };
  },
  methods: {
    /**
     * Callback appelée juste avant l'affichage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onShow: function(bvModalEvt) { //eslint-disable-line no-unused-vars
      // On positionne le flag indiquant si des données utilisateur sont présentes (et donc risquent d'être écrasées)
      this.userDataPresent = (md5(JSON.stringify(this.gpsst)) != window.sessionStorage.getItem("gpsst_md5_initial"));
    },
    saveInJSON: function() {
      const data = JSON.stringify(this.gpsst);
      const blob = new Blob([data], {
        type: "application/json; charset=utf-8"
      });

      var fileName = this.$i18n.t("components.popinSave.saveFile.fileTitle", {
        date: moment().format("YYYY-MM-DD"),
        time: moment().format("HH[h]mm")
      });

      saveAs(blob, fileName);
      this.$bvModal.hide("save");
    },
    isValidJSONString: function(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    openPromptDebugDialog: function() {
      if (this.$store.state.appState.env !== "DEV") {
        return;
      }

      this.promptDebugDialogCount++;

      if (this.promptDebugDialogCount < 8) {
        return;
      }

      var testBackupPath = prompt(
        "Nom sauvegarde test :",
        "stub/sauvegarde-SampleData-PPE-1.gpsst"
      );

      axios
        .get(testBackupPath)
        .then(response => {
          //console.log(response);
          this.loadData(JSON.stringify(response.data));
          this.$bvModal.hide("save");
        })
        .catch(e => {
          alert("Impossible de charger " + testBackupPath);
          console.error(e);
          this.$bvModal.hide("save");
        });
    },    
    openFileDialog: function() {
      // On vérifie d'abord qu'on ne va rien écraser sinon on prévient l'utilisateur
      if (this.userDataPresent) {
        this.$bvModal.show("confirmOverwrite");
      } else {
        document.getElementById("theFile").click();
      }
    },
    cancelOverwrite: function() {
      this.$bvModal.hide("confirmOverwrite");
      this.$bvModal.hide("save");
    },
    confirmOverwrite: function() {
      this.$bvModal.hide("confirmOverwrite");
      document.getElementById("theFile").click();
    },
    openJSON: function(ev) {
      ev.preventDefault();
      var file = ev.target.files[0];
      if (file) {
        var reader = new FileReader();
        var that = this;
        reader.onload = function(e) {
          that.loadData(e.target.result);
          that.$bvModal.hide("save");
        };
        reader.readAsText(file);
      }
    },
    loadData: function(data) {
      if (!this.isValidJSONString(data)) {
        // JSON invalide
        this.$store.commit("SET_ERROR", {
          title: this.$i18n.t("components.popinSave.openFile.title"),
          text: this.$i18n.t("components.popinSave.openFile.errorJsonFormat")
        });
        this.$bvModal.show("error");
        return;
      }

      var newContext = JSON.parse(data);
      if (newContext.appName != "GPSST" || newContext.dataType != "gpsst") {
        // Type de donnée ou app invalide
        this.$store.commit("SET_ERROR", {
          title: this.$i18n.t("components.popinSave.openFile.title"),
          text: this.$i18n.t("components.popinSave.openFile.errorAppName")
        });
        this.$bvModal.show("error");
        return;
      }

      var coV = newContext.dataTypeVersion.split("."),
        cuV = this.gpsst.dataTypeVersion.split(".");
      var result = cuV[0] * 1 == coV[0] * 1 && cuV[1] * 1 >= coV[1] * 1;
      if (result) {
        // on met à jour le store GPSST avec les données chargées
        this.$store.dispatch("overwriteGpsst", newContext);

        // on met à jour le flag indiquant si les champs obligatoires concernant l'entreprise ont été complétés.
        if (
          newContext.compagnyContext.name !== "" &&
          newContext.compagnyContext.unitName !== "" &&
          newContext.compagnyContext.completionPeriods.currentDate !== ""
        ) {
          this.$store.commit("VALIDATE_COMPAGNY_COMPLETED");
        }

        this.$emit("newContextLoaded");
      } else {
        this.$store.commit("SET_ERROR", {
          title: this.$i18n.t("components.popinSave.openFile.title"),
          text: this.$i18n.t("components.popinSave.openFile.errorOldVersion", {
            versionNewFile: newContext.dataTypeVersion,
            currentVersion: this.gpsst.dataTypeVersion
          })
        });
        this.$bvModal.show("error");
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.popin-btn
  display: block
  margin: 1em auto 0 auto
  height: 48px !important
  margin-bottom: 10px !important
</style>
